<div class="section dark">
  <div
    class="asset-version-page"
    (mousedown)="mouseDown($event)"
    (mousemove)="mouseMove($event)"
    #assetViewerSection
    (mouseup)="mouseUp($event)"
    (touchstart)="touchStart($event)"
    (touchmove)="touchMove($event)"
    (touchend)="touchEnd($event)"
    [class.show-gradients]="scale > 1"
    [class.dragging]="dragging"
    [class.can-zoom]="canZoom"
    [class.zoomed-in]="scale > 1"
  >
    @if (version) {
      <app-header [tiny]="true" [class.primary]="version.id === asset.version" [@header]>
        <div class="spacer"></div>
        <a
          appButton
          name="close"
          location="asset-version-header"
          (click)="close()"
          class="close-button"
          height="1"
          color="simple-gray"
          shape="round"
          [appTooltip]="'close-version' | translate"
          [tooltipKeyboardShortcut]="'ESC'"
          toolTipOrigin="left"
          [iconButton]="true"
          data-test-id="version-close"
        >
          <app-svg src="/assets/icons/cross.svg"></app-svg>
        </a>
      </app-header>
    }
    <div
      class="asset-overlay"
      [style.left]="crop.x + 'px'"
      [style.top]="crop.y + 'px'"
      [style.width]="crop.width + 'px'"
      [style.height]="crop.height + 'px'"
      [class.no-transitons]="dragging || zooming || disableOverlayTransitions"
    >
      @if (comparisonMode) {
        <div class="comparison-line" [style.left]="comparisonVisualPosition + '%'"></div>
      }
    </div>
    @if (!comparisonMode) {
      <app-image-viewer-preview
        [asset]="asset"
        [versionData]="version"
        [container]="container"
        [showPreview]="scale > 1 && showControls"
        [noAnimation]="dragging || zooming"
        [scale]="scale"
        [offsetX]="offset.x"
        [offsetY]="offset.y"
        (onPreviewMove)="onPreviewMove($event)"
        *onlyForScreens="['desktop', 'tablet']"
      >
      </app-image-viewer-preview>
    }
    @if (asset.type === 'image') {
      @if (showControls) {
        <div class="asset-viewer-controls-container" [@assetControls]>
          <app-image-viewer-controls
            [scalePercent]="getScalePercent()"
            (scale)="onScale($event)"
            [fitButton]="fitButton"
            *onlyForScreens="['desktop']"
          >
          </app-image-viewer-controls>
        </div>
      }
    }
    @if (asset.type === 'image') {
      <app-image-viewer
        [asset]="asset"
        [comparisonVersion]="comparisonMode ? compareVersion : undefined"
        [comparisonPosition]="comparisonPosition"
        [versionData]="version"
        [noAnimation]="dragging || zooming"
        [offsetX]="offset.x"
        [offsetY]="offset.y"
        [scale]="scale"
        [offsetScale]="offsetScale"
        [sideMenuOpen]="false"
        [showWebGl]="true"
      >
      </app-image-viewer>
    }
    @if (
      asset.type === 'video' && (asset | canDisplayAsset: version) && version
        | assetVersionUrl
          : version.uuid
          : version['status']
          : version.watermark_uuid
          : assetViewerSection.clientWidth
          : false
          : asset.watermark_enabled
          : false
        | async;
      as assetUrl
    ) {
      <app-video-viewer
        [videoData]="$any(version.data)"
        [assetVersion]="version"
        [asset]="asset"
        [scale]="scale"
        [uuid]="version.uuid"
        [origin]="version.asset_name"
        [poster]="assetUrl"
        [active]="true"
        [reportTimeChange]="true"
        [targetWidth]="container.width"
        [showUi]="true"
        [handleUi]="true"
        [handleKeyboardShortcuts]="true"
        [style.left]="crop.x + 'px'"
        [style.top]="crop.y + 'px'"
        [style.width]="crop.width + 'px'"
        [style.height]="crop.height + 'px'"
        (onTimeChange)="videoTime = $event"
      ></app-video-viewer>
    }
  </div>
</div>
<div class="action-container" [@actionContainer]>
  <app-context-menu [options]="{ width: '440px', noSpacing: true }" #menu>
    <button
      appButton
      name="version-menu"
      location="asset-version-page"
      [hasIcon]="true"
      [color]="version.id === asset.version ? 'primary' : 'grey-50'"
      shape="round"
      iconTextSpacing="0"
      height="1"
      size="1"
      weight="bold"
      contextButton
      data-test-id="version-selector"
    >
      <app-svg [src]="'/assets/icons/stack.svg'"></app-svg>

      <span>{{ version.version_name || 'v1' | uppercase }}</span>
      <app-svg src="/assets/icons/18/chevron-down.svg" size="-0-5"></app-svg>
    </button>
    <div contextContent>
      @if (menu.isOpen) {
        <app-asset-version-menu
          contextContent
          [asset]="asset"
          [versions]="versions"
          [selectedVersion]="version"
          [otherSelectedVersion]="comparisonMode ? compareVersion : undefined"
          [accessLevel]="accessLevel"
          [showFooter]="!comparisonMode"
          (onSelect)="switchVersion($event); menu.close()"
          (onClose)="menu.close()"
        ></app-asset-version-menu>
      }
    </div>
  </app-context-menu>

  @if (version) {
    @if (!comparisonMode) {
      <ng-container *onlyForScreens="['desktop', 'tablet']">
        @if (asset.type === 'image') {
          <button
            appButton
            name="compare"
            location="asset-version-page"
            [hasIcon]="true"
            color="dark-blur"
            (click)="toggleComparisonMode()"
            height="1"
            size="1"
            weight="bold"
            shape="round"
            data-test-id="compare"
          >
            <app-svg src="/assets/icons/compare.svg"></app-svg>
            <span>{{ 'compare' | translate }}</span>
          </button>
        }
        @if (accessLevel === 'edit') {
          @if (asset.version !== version.id) {
            <button
              appButton
              name="make-primary"
              location="asset-version-page"
              [hasIcon]="true"
              color="dark-blur"
              shape="round"
              data-test-id="make-primary"
              (click)="makePrimary(version)"
              height="1"
              size="1"
              weight="bold"
            >
              <app-svg src="/assets/icons/stack-top.svg"></app-svg>
              <span>{{ 'make-default' | translate }}</span>
            </button>
          }
        }

        @if (allowDownload) {
          <app-asset-download-button
            location="asset-header"
            [asset]="asset"
            [version]="version"
            [gallery]="gallery"
            [accessLevel]="accessLevel"
          >
            <button
              appButton
              name="download"
              location="asset-header"
              [iconButton]="true"
              shape="round"
              color="simple-gray"
              height="1"
            >
              <app-svg src="/assets/icons/download.svg" color="grey-30"></app-svg>
            </button>
          </app-asset-download-button>
        }

        @if (accessLevel === 'edit') {
          @if (asset.version !== version.id) {
            <button
              appButton
              name="delete"
              location="asset-version-page"
              [iconButton]="true"
              color="dark-blur"
              shape="round"
              (click)="deleteVersion(version)"
              height="1"
              size="1"
              heightMobile="0"
              [class.disabled]="asset.version === version.id"
            >
              <app-svg src="/assets/icons/trash.svg"></app-svg>
            </button>
          }
        }
      </ng-container>
    } @else {
      <button
        appButton
        name="compare-exit"
        location="asset-version-page"
        [iconButton]="true"
        [color]="'white'"
        shape="round"
        appTooltip="Exit Comparison"
        height="1"
        size="1"
        weight="bold"
        data-test-id="close-compare"
        (click)="toggleComparisonMode()"
        contextButton
      >
        <app-svg [src]="'/assets/icons/compare.svg'"></app-svg>
      </button>

      <app-context-menu [options]="{ width: '440px', noSpacing: true }" #menu>
        <button
          appButton
          name="version-menu"
          location="asset-version-page"
          [hasIcon]="true"
          [color]="compareVersion?.id === asset.version ? 'primary' : 'grey-50'"
          shape="round"
          iconTextSpacing="0"
          height="1"
          size="1"
          weight="bold"
          contextButton
          data-test-id="comparison-version-selector"
        >
          <app-svg [src]="'/assets/icons/stack.svg'"></app-svg>

          <span>{{ compareVersion.version_name || 'v1' | uppercase }}</span>
          <app-svg src="/assets/icons/18/chevron-down.svg" size="-0-5"></app-svg>
        </button>
        <div contextContent>
          @if (menu.isOpen) {
            <app-asset-version-menu
              contextContent
              [asset]="asset"
              [versions]="versions"
              [selectedVersion]="compareVersion"
              [otherSelectedVersion]="version"
              (onSelect)="switchCompareVersion($event); menu.close()"
              (onClose)="menu.close()"
            ></app-asset-version-menu>
          }
        </div>
      </app-context-menu>
    }
  }
</div>
